import {
  CommunicationType,
  LogEndpointType,
  TaskStatuses,
} from "@/enums/communicationLogs";

export const TASK_STATUSES_DISPLAY_OPTIONS = {
  [TaskStatuses.todo]: {
    class: "text-gray-400 bg-gray-200/50",
    label: "ACTIVITY.TASK.TO_DO",
  },
  [TaskStatuses.in_progress]: {
    class: "text-blue-400 bg-blue-100/50",
    label: "ACTIVITY.TASK.IN_PROGRESS",
  },
  [TaskStatuses.done]: {
    class: "text-green-400 bg-green-100/50",
    label: "ACTIVITY.TASK.DONE",
  },
};

export const LOG_ENDPOINT_TYPE_TO_LOG_TYPE: Record<
  LogEndpointType,
  CommunicationType
> = {
  [LogEndpointType.CallSession]: CommunicationType.call,
  [LogEndpointType.Task]: CommunicationType.task,
  [LogEndpointType.Sms]: CommunicationType.sms,
};

export const CONTRACT_LINK = "Contract Link" as const;
